/**
 *  @class
 *  @function PredictiveSearch
 */
class PredictiveSearch {
  constructor() {
    this.container = document.getElementById('Search-Drawer');

    if (!this.container) return;

    this.form = this.container.querySelector('.search-drawer--searchform');
    this.button = document.querySelectorAll('.thb-quick-search');
    this.input = this.container.querySelector('input[type="search"]');
    this.predictiveSearchResultsWrapper = this.container.querySelector('.search-drawer--inner');
    this.predictiveSearchResults = this.predictiveSearchResultsWrapper.querySelector('.thb-predictive-search');

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    this.button.forEach((item) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();

        document.body.classList.toggle('open-search');
        document.body.classList.toggle('open-cc');

        if (document.body.classList.contains('open-search')) {
          setTimeout(() => {
            this.input.focus({
              preventScroll: true
            });
          }, 100);

          dispatchCustomEvent('search:open');
        }

        return false;
      });
    });
  }

  getQuery() {
    return this.input.value.trim();
  }

  getPredictiveFields() {
    return 'title,product_type,variants.title,variants.sku,variants.barcode,vendor';
  }

  buildSuggestSectionUrl(searchTerm) {
    const params = new URLSearchParams();

    params.set('q', searchTerm);
    params.set('resources[type]', 'product,collection,article,query');
    params.set('resources[limit]', '6');
    params.set('resources[options][fields]', this.getPredictiveFields());
    params.set('section_id', 'predictive-search');

    return `${theme.routes.predictive_search_url}?${params.toString()}`;
  }

  buildSuggestJsonUrl(searchTerm) {
    const params = new URLSearchParams();

    params.set('q', searchTerm);
    params.set('resources[type]', 'product');
    params.set('resources[limit]', '10');
    params.set('resources[options][fields]', this.getPredictiveFields());

    let suggestUrl = theme.routes.predictive_search_url || '/search/suggest';

    if (!suggestUrl.includes('.json')) {
      suggestUrl = suggestUrl.replace('/search/suggest', '/search/suggest.json');
    }

    return `${suggestUrl}?${params.toString()}`;
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.container.classList.remove('active');
      return;
    }

    this.container.classList.add('active');
    this.getSearchResults(searchTerm);
  }

  async onFormSubmit(event) {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      event.preventDefault();
      return;
    }

    event.preventDefault();

    try {
      const response = await fetch(this.buildSuggestJsonUrl(searchTerm));

      if (!response.ok) {
        throw new Error(response.status);
      }

      const data = await response.json();
      const products = data?.resources?.results?.products || [];

      /*
        If SKU / barcode finds a matching product,
        directly open that product.
      */
      if (products.length > 0 && products[0].url) {
        window.location.href = products[0].url;
        return;
      }
    } catch (error) {
      console.warn('SKU / barcode predictive lookup failed:', error);
    }

    /*
      Fallback normal Shopify search
    */
    const searchUrl = new URL(this.form.action, window.location.origin);
    searchUrl.searchParams.set('q', searchTerm);
    searchUrl.searchParams.set('type', 'product');
    searchUrl.searchParams.set('options[prefix]', 'last');

    window.location.href = searchUrl.toString();
  }

  onFocus() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    this.predictiveSearchResults.classList.add('loading');

    fetch(this.buildSuggestSectionUrl(searchTerm))
      .then((response) => {
        this.predictiveSearchResults.classList.remove('loading');

        if (!response.ok) {
          throw new Error(response.status);
        }

        return response.text();
      })
      .then((text) => {
        const resultsContainer = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search');

        if (!resultsContainer) return;

        const resultsMarkup = resultsContainer.innerHTML;

        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        this.predictiveSearchResults.classList.remove('loading');
        console.warn('Predictive search error:', error);
      });
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;

    const submitButton = this.container.querySelector('#search-results-submit');

    if (document.body.classList.contains('animations-true') && typeof gsap !== 'undefined') {
      gsap.to(
        this.predictiveSearchResults.querySelectorAll('.product-card .product-featured-image-link'),
        {
          scale: 1,
          opacity: 1,
          stagger: 0.15,
          ease: window.theme.settings.animation_easing
        }
      );
    }

    if (submitButton) {
      submitButton.addEventListener('click', () => {
        this.form.requestSubmit();
      });
    }
  }

  close() {
    this.container.classList.remove('active');
  }
}

window.addEventListener('load', () => {
  if (typeof PredictiveSearch !== 'undefined') {
    new PredictiveSearch();
  }
});